export const input = [
  {
    "id": 0,
    "original": "Where is the Orange Bowl ?",
    "label": "Location",
    "augment": [
      {
        "origin": "InvDA",
        "sentence": "Where is the Orange Bowl held?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.5192000209682432
      },
      {
        "origin": "InvDA",
        "sentence": "Where is the Orange Bowl played in?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9299996823405381
      },
      {
        "origin": "InvDA",
        "sentence": "Where is the Orange Bowl in San Diego?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8152793819399102
      },
      {
        "origin": "InvDA",
        "sentence": "Where is the Orlando Orange Bowl held?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9823403590439913
      },
      {
        "origin": "InvDA",
        "sentence": "Where is the Orange Bowl?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8095497947975963
      },
      {
        "origin": "InvDA",
        "sentence": "Where is the Orange Bowl located?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9775511848067843
      },
      {
        "origin": "InvDA",
        "sentence": "Where is the Orange Bowl played?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9714403452575785
      },
      {
        "origin": "Deletion",
        "sentence": "Where is the ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.6827149827125101
      },
      {
        "origin": "Deletion",
        "sentence": "is the Orange Bowl ?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.776619796293971
      },
      {
        "origin": "Deletion",
        "sentence": "Where Orange Bowl ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9911215834332014
      },
      {
        "origin": "Deletion",
        "sentence": "the Orange Bowl ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8223437219105247
      },
      {
        "origin": "Deletion",
        "sentence": "Where is the Orange",
        "label": "Location",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9007192694702835
      },
      {
        "origin": "Deletion",
        "sentence": "Where is the Orange Bowl",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7984918373929261
      },
      {
        "origin": "Deletion",
        "sentence": "Where is Bowl ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.7902406400559323
      },
      {
        "origin": "Replacement",
        "sentence": "Where is the Orange arena ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9194753562964018
      },
      {
        "origin": "Replacement",
        "sentence": "Where cost the Orange Bowl ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.5015422005797265
      },
      {
        "origin": "Replacement",
        "sentence": "Where personify the Orange Bowl ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.6667666351457608
      },
      {
        "origin": "Replacement",
        "sentence": "where is the Orange Bowl ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9958085703028945
      },
      {
        "origin": "Replacement",
        "sentence": "Where is the orangish Bowl ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7846788045725842
      },
      {
        "origin": "Replacement",
        "sentence": "Where is the orangeness Bowl ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9134863463823409
      },
      {
        "origin": "Replacement",
        "sentence": "Where is the Orange roll ?",
        "label": "Location",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9459992133867305
      }
    ]
  },
  {
    "id": 1,
    "original": "What is Nicholas Cage 's profession ?",
    "label": "Human",
    "augment": [
      {
        "origin": "InvDA",
        "sentence": "What is Nicholas Cage's profession?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7782795279646858
      },
      {
        "origin": "InvDA",
        "sentence": "What is Nicholas Cage's formal profession?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9054453921773254
      },
      {
        "origin": "InvDA",
        "sentence": "What is Nicholas Cage's career in?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.5695413112392269
      },
      {
        "origin": "InvDA",
        "sentence": "What is Nicholas Cage's career as a lawyer?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.5583643588714711
      },
      {
        "origin": "InvDA",
        "sentence": "What is Nicholas Cage's career name?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8894052442607124
      },
      {
        "origin": "InvDA",
        "sentence": "What is Nicholas Cage's professional profession?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.786333774810285
      },
      {
        "origin": "InvDA",
        "sentence": "What is Nicholas Cage's professional specialization?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": true,
        "weight": 0.3856071849832805
      },
      {
        "origin": "Deletion",
        "sentence": "Nicholas Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8262503697618255
      },
      {
        "origin": "Deletion",
        "sentence": "What is Nicholas 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8470581068967521
      },
      {
        "origin": "Deletion",
        "sentence": "What Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9536287841589353
      },
      {
        "origin": "Deletion",
        "sentence": "What is Nicholas Cage 's",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.7814317127145386
      },
      {
        "origin": "Deletion",
        "sentence": "What is Nicholas Cage ?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9285238150689236
      },
      {
        "origin": "Deletion",
        "sentence": "What is Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7837289797639176
      },
      {
        "origin": "Deletion",
        "sentence": "What is 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.7974442475867296
      },
      {
        "origin": "Replacement",
        "sentence": "What is nicholas Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9887302569816719
      },
      {
        "origin": "Replacement",
        "sentence": "What personify Nicholas Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7948486681591475
      },
      {
        "origin": "Replacement",
        "sentence": "what is Nicholas Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9955275091764914
      },
      {
        "origin": "Replacement",
        "sentence": "What is Nicholas Cage 's professing ?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9417815115767255
      },
      {
        "origin": "Replacement",
        "sentence": "What embody Nicholas Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7123792206674869
      },
      {
        "origin": "Replacement",
        "sentence": "What constitute Nicholas Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9822827129436841
      },
      {
        "origin": "Replacement",
        "sentence": "What is Nicholas Cage 's profession ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.970481859318459
      }
    ]
  },
  {
    "id": 2,
    "original": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to become ?",
    "label": "Entity",
    "augment": [
      {
        "origin": "InvDA",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to become to be known as?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9374595125380891
      },
      {
        "origin": "InvDA",
        "sentence": "What does Dan Aykroyd and John Belushi quit Saturday Night Live to become?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9479067703140157
      },
      {
        "origin": "InvDA",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to become in television?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7250833046122349
      },
      {
        "origin": "InvDA",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to become when they both joined California?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.5701466360652419
      },
      {
        "origin": "InvDA",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to become before they became CEOs?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8952995166795554
      },
      {
        "origin": "InvDA",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to become to become?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.4464083170915737
      },
      {
        "origin": "InvDA",
        "sentence": "What was the name of Dan Aykroyd and John Belushi when they quit Saturday Night Live to become television executives?",
        "label": "Human",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8891459589842114
      },
      {
        "origin": "Deletion",
        "sentence": "What Dan Aykroyd and John Belushi quit Saturday Night Live to become ?",
        "label": "Human",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9708195213354269
      },
      {
        "origin": "Deletion",
        "sentence": "What did Dan Aykroyd and Belushi quit Saturday Night Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7300264008369772
      },
      {
        "origin": "Deletion",
        "sentence": "What did Dan Aykroyd and John Belushi quit Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.5434066415098748
      },
      {
        "origin": "Deletion",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8731197289625882
      },
      {
        "origin": "Deletion",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.6961593124515826
      },
      {
        "origin": "Deletion",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.7761237388127961
      },
      {
        "origin": "Deletion",
        "sentence": "What did Dan Aykroyd and quit Saturday Night Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7869937536948161
      },
      {
        "origin": "Replacement",
        "sentence": "What did Dan aykroyd and John Belushi quit Saturday Night Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.44465563162102373
      },
      {
        "origin": "Replacement",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday dark Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8623532833630315
      },
      {
        "origin": "Replacement",
        "sentence": "What practice Dan Aykroyd and John Belushi quit Saturday Night Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7963900179020788
      },
      {
        "origin": "Replacement",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to turn ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7419521889295755
      },
      {
        "origin": "Replacement",
        "sentence": "what did Dan Aykroyd and John Belushi quit Saturday Night Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9608885129704515
      },
      {
        "origin": "Replacement",
        "sentence": "What did Dan Aykroyd and John Belushi quit Saturday Night Live to suit ?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.7614386453396587
      },
      {
        "origin": "Replacement",
        "sentence": "What did Dan Aykroyd and John belushi quit Saturday Night Live to become ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.917509736142892
      }
    ]
  },
  {
    "id": 3,
    "original": "What is the name of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors ?",
    "label": "Entity",
    "augment": [
      {
        "origin": "InvDA",
        "sentence": "What is the name of the 1919 event in which British troops killed over 3 unarmed Indian protestors?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9123072437636551
      },
      {
        "origin": "InvDA",
        "sentence": "What is the name of the 1919 incident in which British troops killed over 3 thousand unarmed Indian protestors?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.950975902170923
      },
      {
        "origin": "InvDA",
        "sentence": "What is the name of the 1919 incident in which British troops killed over 50,000 unarmed Indian protestors?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9411792386297273
      },
      {
        "origin": "InvDA",
        "sentence": "What is the name of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors during India occupation?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9766363991724121
      },
      {
        "origin": "InvDA",
        "sentence": "What is the name of the 1919 landmark occurrence in which British troops killed over 3 hundred unarmed Indian protestors during a ceasefire in India?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9634315397204285
      },
      {
        "origin": "InvDA",
        "sentence": "What is the name of the 1919 incident in which British troops killed over 3 unarmed Indian protestors?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.5933185297434205
      },
      {
        "origin": "InvDA",
        "sentence": "What is the name of the 1919 occurrence in which British troops killed over 3 unarmed Indians after protestors called?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.6183194009941532
      },
      {
        "origin": "Deletion",
        "sentence": "What is the name 1919 occurrence in which British troops killed over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8071580738965003
      },
      {
        "origin": "Deletion",
        "sentence": "What is the of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors ?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.7739987728566406
      },
      {
        "origin": "Deletion",
        "sentence": "What is the name of the 1919 occurrence in British troops killed over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.977979797708331
      },
      {
        "origin": "Deletion",
        "sentence": "is the name of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.880133104367782
      },
      {
        "origin": "Deletion",
        "sentence": "What is the name of occurrence in which British troops killed over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8986838460479744
      },
      {
        "origin": "Deletion",
        "sentence": "What is the name of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8170093679612126
      },
      {
        "origin": "Deletion",
        "sentence": "What is the name of the 1919 occurrence in which killed over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9504444523167743
      },
      {
        "origin": "Replacement",
        "sentence": "What is the name of the 1919 occurrence in which British troops killed over tierce unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8752967598621479
      },
      {
        "origin": "Replacement",
        "sentence": "What is the name of the 1919 occurrence in which British troops down over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8322337422849619
      },
      {
        "origin": "Replacement",
        "sentence": "What is the identify of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors ?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.676138886830717
      },
      {
        "origin": "Replacement",
        "sentence": "What is the name of the 1919 occurrence in which British troops killed over 3 unarmed amerindic protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7909108712351909
      },
      {
        "origin": "Replacement",
        "sentence": "what is the name of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9659550279217837
      },
      {
        "origin": "Replacement",
        "sentence": "What is the name of the 1919 occurrence in which British soldiery killed over 3 unarmed Indian protestors ?",
        "label": "Entity",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9001874939417592
      },
      {
        "origin": "Replacement",
        "sentence": "What is the key of the 1919 occurrence in which British troops killed over 3 unarmed Indian protestors ?",
        "label": "Description",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.04104355451889807
      }
    ]
  },
  {
    "id": 4,
    "original": "What does a teaspoon of matter weigh in a black hole ?",
    "label": "Numeric",
    "augment": [
      {
        "origin": "InvDA",
        "sentence": "What does a teaspoon of matter weigh in a black hole?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.4431466238803119
      },
      {
        "origin": "InvDA",
        "sentence": "What does a teaspoon of sand and water weigh in a black hole?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.6374810554261994
      },
      {
        "origin": "InvDA",
        "sentence": "What does a teaspoon of ground matter weigh in a black hole?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9797042382429453
      },
      {
        "origin": "InvDA",
        "sentence": "What does a pound of water weigh and weigh in a black hole?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9875803063302269
      },
      {
        "origin": "InvDA",
        "sentence": "What does a teaspoon of black matter weigh in a black hole?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.7427541092974945
      },
      {
        "origin": "InvDA",
        "sentence": "What does a teaspoon of sand make of matter weigh in a black hole?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": true,
        "weight": 0.8127700975665546
      },
      {
        "origin": "InvDA",
        "sentence": "What does a teaspoon of water weigh in a black hole?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8167737688983912
      },
      {
        "origin": "Deletion",
        "sentence": "What does a teaspoon of matter weigh in a black hole",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8969500493298675
      },
      {
        "origin": "Deletion",
        "sentence": "What teaspoon of matter weigh in a black hole ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9607184403369833
      },
      {
        "origin": "Deletion",
        "sentence": "What does a teaspoon of matter weigh a black hole ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7662259648053316
      },
      {
        "origin": "Deletion",
        "sentence": "What does a teaspoon of matter a black hole ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9429587409561958
      },
      {
        "origin": "Deletion",
        "sentence": "What does a teaspoon of matter weigh in a black",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8366733641137447
      },
      {
        "origin": "Deletion",
        "sentence": "What does of matter weigh in a black hole ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9791592129338713
      },
      {
        "origin": "Deletion",
        "sentence": "What does a teaspoon of weigh in a black hole ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9323165547343493
      },
      {
        "origin": "Replacement",
        "sentence": "What does a teaspoon of matter weigh in a sinister hole ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9138773223861529
      },
      {
        "origin": "Replacement",
        "sentence": "What does a teaspoon of matter weigh in a black jam ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8629218943465292
      },
      {
        "origin": "Replacement",
        "sentence": "What does a teaspoon of matter librate in a black hole ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9035506225360841
      },
      {
        "origin": "Replacement",
        "sentence": "What does a teaspoon of matter consider in a black hole ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8842880438416204
      },
      {
        "origin": "Replacement",
        "sentence": "What does a teaspoon of matter weigh in a blacken hole ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9310160920615795
      },
      {
        "origin": "Replacement",
        "sentence": "What does a teaspoonful of matter weigh in a black hole ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.7125532404528857
      },
      {
        "origin": "Replacement",
        "sentence": "What does a teaspoon of matter weigh in a black hollow ?",
        "label": "Numeric",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.7948777732180311
      }
    ]
  },
  {
    "id": 5,
    "original": "What toy company is the world 's No.1 maker of female apparel ?",
    "label": "Human",
    "augment": [
      {
        "origin": "InvDA",
        "sentence": "What toy company is the world's No.1 maker of women's clothing?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9907555559605727
      },
      {
        "origin": "InvDA",
        "sentence": "What toy company is the world's No.1 maker of women's clothing made in?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9341613657241647
      },
      {
        "origin": "InvDA",
        "sentence": "What toy company is the world's No.1 maker of male clothing and makeup products?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8160925949030031
      },
      {
        "origin": "InvDA",
        "sentence": "What toy company is the world's No.1 maker of female apparel?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9639613433190038
      },
      {
        "origin": "InvDA",
        "sentence": "What toys company is the world's No.1 maker of feminine apparel?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8954605906801625
      },
      {
        "origin": "InvDA",
        "sentence": "What toy company is the world's No.1 maker of female clothing and footwear?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.819535411899413
      },
      {
        "origin": "InvDA",
        "sentence": "What toy company is the world's No.1 maker of female apparel and shoes?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9907592801378982
      },
      {
        "origin": "Deletion",
        "sentence": "What toy is the world 's No.1 maker of female apparel ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9937446353592461
      },
      {
        "origin": "Deletion",
        "sentence": "What toy company is the world 's of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.587220685105247
      },
      {
        "origin": "Deletion",
        "sentence": "What toy company the world 's No.1 maker of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.5788976356516613
      },
      {
        "origin": "Deletion",
        "sentence": "What toy company is the world 's No.1 maker female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9237916315772117
      },
      {
        "origin": "Deletion",
        "sentence": "What toy company is the world No.1 maker of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9527521795153474
      },
      {
        "origin": "Deletion",
        "sentence": "What toy company is the world 's No.1 female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9324570578332203
      },
      {
        "origin": "Deletion",
        "sentence": "What company is the world 's No.1 maker of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8664631256806478
      },
      {
        "origin": "Replacement",
        "sentence": "What toy companion is the world 's No.1 maker of female apparel ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.6710400648175734
      },
      {
        "origin": "Replacement",
        "sentence": "What toy company is the world 's No.1 maker of female garment ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8283415343392432
      },
      {
        "origin": "Replacement",
        "sentence": "What dally company is the world 's No.1 maker of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.9357304666077806
      },
      {
        "origin": "Replacement",
        "sentence": "What toy company is the world 's No.1 maker of female clothes ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.6823745624956702
      },
      {
        "origin": "Replacement",
        "sentence": "what toy company is the world 's No.1 maker of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8885931976018147
      },
      {
        "origin": "Replacement",
        "sentence": "What toy company is the world-wide 's No.1 maker of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8484770453724184
      },
      {
        "origin": "Replacement",
        "sentence": "What toy company is the humanity 's No.1 maker of female apparel ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8116571758787946
      }
    ]
  },
  {
    "id": 6,
    "original": "What Italian liner was hijacked in 1985 ?",
    "label": "Human",
    "augment": [
      {
        "origin": "InvDA",
        "sentence": "What Italian airline passenger plane was hijacked in 1985?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.5007697573649255
      },
      {
        "origin": "InvDA",
        "sentence": "What Italian airliner was hijacked in Italy in 1985?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.794363431586175
      },
      {
        "origin": "InvDA",
        "sentence": "What Italian passenger jet was hijacked in 1985 by a mysterious foreign entity?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8915518798434701
      },
      {
        "origin": "InvDA",
        "sentence": "What Italian passenger ship was hijacked in 1985?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8998451942240937
      },
      {
        "origin": "InvDA",
        "sentence": "What Italian passenger airline was hijacked in August 1985?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9046159908708007
      },
      {
        "origin": "InvDA",
        "sentence": "What Italian ocean liner was hijacked by pirates in 1985?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.5830117373085678
      },
      {
        "origin": "InvDA",
        "sentence": "What Italian airliner was hijacked by the American fleet in 1985?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.644892159661715
      },
      {
        "origin": "Deletion",
        "sentence": "What was hijacked in 1985 ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9249753933614455
      },
      {
        "origin": "Deletion",
        "sentence": "What Italian liner hijacked in 1985 ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.9055060281164209
      },
      {
        "origin": "Deletion",
        "sentence": "What Italian liner was hijacked ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.4744443756833521
      },
      {
        "origin": "Deletion",
        "sentence": "What Italian liner was 1985 ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8809126070740179
      },
      {
        "origin": "Deletion",
        "sentence": "Italian liner was hijacked in 1985 ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9138212330835352
      },
      {
        "origin": "Deletion",
        "sentence": "liner was hijacked in 1985 ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.9122709822219128
      },
      {
        "origin": "Deletion",
        "sentence": "What Italian liner was hijacked in 1985",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.5197057861300913
      },
      {
        "origin": "Replacement",
        "sentence": "What Italian liner was hijacked in 1985 ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.6859275977134178
      },
      {
        "origin": "Replacement",
        "sentence": "What Italian liner was hijack in 1985 ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.716500573216104
      },
      {
        "origin": "Replacement",
        "sentence": "what Italian liner was hijacked in 1985 ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8136449958848304
      },
      {
        "origin": "Replacement",
        "sentence": "What Italian liner embody hijacked in 1985 ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": false,
        "weight": 0.8891376105560453
      },
      {
        "origin": "Replacement",
        "sentence": "What Italian lining was hijacked in 1985 ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": true,
        "weight": 0.95261630915611
      },
      {
        "origin": "Replacement",
        "sentence": "What Italian liner represent hijacked in 1985 ?",
        "label": "Human",
        "label_accurate": true,
        "in_batch": true,
        "weight": 0.8470750883004369
      },
      {
        "origin": "Replacement",
        "sentence": "What italian liner was hijacked in 1985 ?",
        "label": "Entity",
        "label_accurate": false,
        "in_batch": false,
        "weight": 0.8016132616052386
      }
    ]
  }
]
